import oauth from './oauth'
import stateActions from './stateActions';

export const actions = {
    oauth,
    ...stateActions,
};

export default actions;
